import { cva } from 'class-variance-authority';

const tableCellBaseStyles = ['whitespace-nowrap', 'px-6', 'py-3'];

const tableCellStylesSAG = cva([...tableCellBaseStyles]);

const tableCellStylesSHS = cva([...tableCellBaseStyles]);

export { tableCellStylesSAG, tableCellStylesSHS };
